import { Tooltip } from '@material-ui/core';
import { PPModal, PPInput } from 'processor-plataform-ui';
import React, { useState } from 'react';
import { formatDecimal, filterDecimalInput } from '../../services/currency';
import BudgetPerMonth from './BudgetPerMonth';
import { CostCenterModel } from '../../services/finOpsManagerService';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { UserState } from '../../store/reducers/userReducer';
import { useSnackbar } from 'notistack';
import JSONDigger from "json-digger";
import { NewCostCenterModel } from './costCenter.Models';
import { filterDefault } from '.';
import { CostCenterService } from '../../services/costCenter/costCenterService';
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";

interface CreateorEditCCModalProps {
    currentNode: CostCenterModel
    typeSideModal: string;
    isVisibleEditCostCenter: boolean
    currentRow: CostCenterModel
    saveMode: number
    onCloseCostCenter: () => void
    setSaveMode: (value: number) => void
    setTypeSideModal: (value: string) => void
    updateTree: (costCenter?: NewCostCenterModel | null) => void
}

export const CreateOrEditCCModal: React.FC<CreateorEditCCModalProps> = (props) => {
    const service = new CostCenterService(props);
    const user = useSelector<RootState, UserState>(state => state.user);
    const [newCcName, setNewCcName] = useState<string>('')
    const [CcName, setCcName] = useState<string>('')
    const [CcBudget, setCcBudget] = useState<string>()
    const [newCcBudget, setNewCcBudget] = useState<string>('0')
    const [monthBudgetFull, setMonthBudgetFull] = useState<{ month: string, value: number }[]>([]);
    const [isVisibleEditCostCenter, setIsVisibleEditCostCenter] = useState<boolean>(false)
    const { enqueueSnackbar } = useSnackbar();
    const [ds, setDS] = useState(filterDefault);
    const dsDigger = new JSONDigger(ds, "id", "children");

    const onChangeInput = (event) => {

        const { value, name } = event.target;

        switch (name) {
            case "costCenter_name":
                setCcName(value)
                break;
            case "costCenter_budget":
                setCcBudget(filterDecimalInput(value))
                break;
        }
    }

    const handleUpdateBudgetMonth = (e) => {
        let newMonthBudgetfull = [...monthBudgetFull];
        e.forEach(budget => {
            newMonthBudgetfull.map(mbf => mbf.month === budget.month ? mbf.value = budget.value : mbf);
        });
        setMonthBudgetFull(newMonthBudgetfull);
    }

    const addChild = async () => {
        enqueueSnackbar(
            "A criação do centro de custo foi iniciada, aguarde a atualização dos dados",
            {
                variant: "success",
                preventDuplicate: true,
                persist: false,
            }
        );
        setIsVisibleEditCostCenter(!isVisibleEditCostCenter);
        props.setTypeSideModal('');

        let param = props.currentNode.costCenterId;
        let newNode = {
            id: uuidv4(),
            name: newCcName,
            baseline: 0,
            nodeContent: "",
            tag: newCcName,
            baselineUndefined: false,
            budget: newCcBudget,
            qtdSubscription: 0,
            children: [],
            clientGroupId: user.ClientGroupSelected,
        }

        await dsDigger.addChildren(param, [newNode]);
        await dsDigger.findParent(newNode.id).then((_r) => {
            const parentNode = _r;
            const node = newNode;

            let costCenterSend: NewCostCenterModel = {
                ID: 0,
                Parent: parentNode.id,
                Main: false,
                Name: node.name,
                ParentName: parentNode.name,
                Budget: newCcBudget,
                QtdSubscription: node.qtdSubscription,
                ClientGroupId: user.ClientGroupSelected,
                active: true
            }
            service
                .UpdateCostCenter(costCenterSend)
                .then((result) => {
                    if (result.status === 200) {
                        props.updateTree(costCenterSend)
                        setNewCcName("");
                        setNewCcBudget("0");
                        enqueueSnackbar(
                            "A atualização do centro de custo foi realizada com sucesso.",
                            {
                                variant: "success",
                                preventDuplicate: true,
                                persist: false,
                            }
                        );
                    }
                })
                .catch((error) => {
                    console.error(error);
                    enqueueSnackbar("Erro ao atualizar centro de custo.", {
                        variant: "error",
                        preventDuplicate: true,
                        persist: false,
                    });
                });
        });

        setDS({ ...dsDigger.ds });
    };

    const updateCostCenter = async () => {
        if (props.saveMode === -1) {
            var currentBudgetHistory: any[] = [];
            try {
                let result = await service.GetTreeDataWithBudget();
                if (result.status === 200)
                    currentBudgetHistory = result.data.map(d => d.monthBudget).flat();
            } catch (error) {
                console.warn(error);
            }

            monthBudgetFull.find(b => b.value) ?
                enqueueSnackbar('A atualização do centro de custo foi iniciada, aguarde.', {
                    variant: 'info',
                    preventDuplicate: true,
                    persist: false,
                })
                :
                enqueueSnackbar('Não há dados para serem salvos', {
                    variant: 'warning',
                    preventDuplicate: true,
                    persist: false,
                })

            monthBudgetFull
                // .filter(b => b.value)
                .forEach(async (mb, index) => {
                    try {
                        let parsedValue = Number(mb.value) || 0.00;
                        let hasHistory = currentBudgetHistory.length > 0;
                        let hasChanged = hasHistory && !(currentBudgetHistory.some(cbh =>
                            cbh.costCenterId === props.currentRow.costCenterId && cbh.value === parsedValue && cbh.month === mb.month
                        ));
                        if (!hasHistory || hasChanged)
                            await service.CreateOrUpdateBudget(props.currentRow.costCenterId, parsedValue, mb.month);
                    } catch (error) {
                        console.warn(error);
                    }
                    if (monthBudgetFull.filter(b => b.value).length - 1 == index) {
                        props.updateTree();
                        enqueueSnackbar('A atualização do centro de custo foi realizada com sucesso.', {
                            variant: 'success',
                            preventDuplicate: true,
                            persist: false,
                        })
                        props.onCloseCostCenter();
                    }
                })

        } else {
            enqueueSnackbar('A atualização do centro de custo foi iniciada, aguarde.', {
                variant: 'info',
                preventDuplicate: true,
                persist: false,
            })

            let costCenterSend = {
                ID: props.currentRow.costCenterId,
                Parent:props.currentRow.parentId,
                Main: false,
                Name: CcName,
                Active: props.currentRow.active,
                ParentName: props.currentRow.parentName,
                QtdSubscription: props.currentRow.qtdSubscription,
                Budget: CcBudget,
                ClientGroupId: user.ClientGroupSelected
            }

            try {

                var result = await service.UpdateCostCenter(costCenterSend);
                if (result.status === 200) {
                    let budgetMsg = "";
                    var budget = {
                        id: props.currentRow.costCenterId,
                        value: Number(CcBudget) || 0.00,
                        month: moment().format("YYYY-MM")
                    }
                    var resultBudget = await service.CreateOrUpdateBudget(budget.id, budget.value, budget.month);

                    if (resultBudget.status == 200)
                        budgetMsg = " e do histórico de orçamentos";

                    props.updateTree()
                    enqueueSnackbar(`A atualização do centro de custo${budgetMsg} foi realizada com sucesso.`, {
                        variant: 'success',
                        preventDuplicate: true,
                        persist: false,
                    })
                    props.onCloseCostCenter()
                }
            } catch (error) {
                console.error(error)
                enqueueSnackbar('Erro ao atualizar centro de custo.', {
                    variant: 'error',
                    preventDuplicate: true,
                    persist: false,
                })
            }

        }
    }

    return (
        <PPModal
            title={
                props.typeSideModal === "edit"
                    ? "Editar centro de custo"
                    : "Criar centro de custo"
            }
            onClose={props.onCloseCostCenter}
            visible={props.isVisibleEditCostCenter}
        >
            {props.currentRow && props.typeSideModal === 'edit' &&
                <div className='form gap-tiny mr-3'>
                    <PPInput
                        title='Nome do centro de custo'
                        value={CcName} name="costCenter_name"
                        type="text"
                        onChange={onChangeInput}
                        placeholder="Insira um novo nome ao centro de custo"
                        required
                    />
                    {
                        props.saveMode === 1 ?
                            <PPInput
                                title='Valor de orçamento (período atual)'
                                value={CcBudget ? formatDecimal(Number(CcBudget)) : '0.00'}
                                decoration="R$ "
                                name="costCenter_budget"
                                type="text"
                                placeholder="Digite apenas números"
                                onChange={onChangeInput}
                                required
                            />
                            :
                            <BudgetPerMonth clientGroupId={user.ClientGroupSelected} ccId={props.currentRow.costCenterId} onChange={handleUpdateBudgetMonth} />
                    }

                </div>
            }
            {
                props.typeSideModal === 'create' &&
                <div className='form gap-tiny mr-3'>
                    <PPInput
                        title='Nome do centro de custo'
                        value={newCcName}
                        name="newCostCenterName"
                        type="text"
                        onChange={(e) => setNewCcName(e.target.value)}
                        placeholder="Insira um novo nome ao centro de custo"
                        required
                    />

                    {
                        props.saveMode === 1 ?
                            <PPInput
                                title='Valor de orçamento (período atual)'
                                value={newCcBudget ? formatDecimal(Number(newCcBudget)) : '0.00'}
                                decoration="R$ "
                                name="newCostCenterBudget"
                                type="text"
                                placeholder="Digite apenas números"
                                onChange={(e) => { setNewCcBudget(filterDecimalInput(e.target.value)) }}
                                required
                            />
                            :
                            <BudgetPerMonth clientGroupId={user.ClientGroupSelected} ccId={props.currentRow.costCenterId} onChange={handleUpdateBudgetMonth} />
                    }

                </div>

            }
            <div className="space-between pv-5">
                <button className='pp-button bg-info ml-3' onClick={() => props.typeSideModal ==="edit" ?
                    updateCostCenter() 
                    :
                    addChild()}
                    >
                        {props.typeSideModal === "edit" ? "Salvar" : "Criar"}
                    </button>
                    {
                        props.typeSideModal === 'edit' &&
                        <Tooltip placement="top" arrow  title={props.saveMode === 1 ? "Editar orçamento separado por mês" : "Editar orçamento padrão do centro de custo"}>
                            <button className='pp-button bg-info mr-3' onClick={() => props.setSaveMode(props.saveMode * -1)}>{props.saveMode === 1 ? "Histórico" : "Modo Padrão"}</button>
                        </Tooltip>
                    }
            </div>
        </PPModal> 
    )
}